import { StorageInterface } from '../Context/ShoppingPlannerContext';

export function persistAnswers(answers: StorageInterface, locale: string): Promise<{ slug: string }> {
    return fetch('/api/shopping-planner/answers/' + (answers.slug ?? ''), {
        method: 'POST',
        body: JSON.stringify({
            answersJson: JSON.stringify({ answers }),
        }),
        headers: {
            'Accept-Language': locale,
            credentials: 'include',
        },
    })
        .then((response) => response.json())
        .then((response) => response.data);
}

export function readAnswers(slug: string): Promise<{ answers: StorageInterface }> {
    return fetch('/api/shopping-planner/answers/' + slug)
        .then((response) => response.json())
        .then((response) => JSON.parse(response.data.answersJson));
}
